import React from 'react';
import { ConfirmModal } from '../confirm-modal';
import TextBase from '../text';
import { Colors } from '../../themes/Colors';
import { translate } from '../../helper';

const paymentMethodBtnStyle = {
  width: '100%',
  padding: 'calc(var(--sp-md2)*1.69811) calc(var(--sp-md2)*1.32075)',
  borderRadius: 'calc(var(--sp-md2)*1.50943396)',
  border: '1px solid #E5E7EB',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  background: '#FAFAFA',
  boxShadow: '0px 2px 6px rgba(0,0,0,0.04)'
};

export function AddPaymentMethodModal({
  open,
  onClose,
  onAddBank,
  onAddCard,
}) {
  return (
    <ConfirmModal
      visible={open}
      status="warning"
      onClose={onClose}
      showButtons={false}
      handleCancel={onClose}
    >
      <TextBase
        style={{ textAlign: 'center', marginBottom: 'calc(var(--sp-lg)*1.132075)' }}
        fontWeight={700}
        size={'calc(var(--fs-xl)*1.037735)'}
        color={Colors.black}
      >
        {translate("selectPaymentMethod")}
      </TextBase>

      <div
        onClick={onAddBank}
        style={{ ...paymentMethodBtnStyle, marginBottom: 'calc(var(--sp-md2)*1.50943396)' }}
      >
        <span style={{ fontSize: 30, marginRight: 'calc(var(--sp-md2)*1.50943396)' }}>🏦</span>
        <TextBase fontWeight={600} size={'calc(var(--fs-xs)*1.50943396)'} color={Colors.black}>
          {translate("addBankACH")}
        </TextBase>
      </div>
      <div
        onClick={onAddCard}
        style={paymentMethodBtnStyle}
      >
        <span style={{ fontSize: 30, marginRight: 'calc(var(--sp-md2)*1.50943396)' }}>💳</span>
        <TextBase fontWeight={600} size={'calc(var(--fs-xs)*1.50943396)'} color={Colors.black}>
          {translate("addNewCard")}
        </TextBase>
      </div>
    </ConfirmModal>
  );
}
